import { useAuthStore } from '../lib/auth';
import { Link } from 'react-router-dom';

export default function DashboardPage() {
  const { user } = useAuthStore();

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 32 }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 48 }}>
        <h1 style={{ fontSize: 20 }}>Detailer Growth OS</h1>
        <span style={{ color: 'var(--color-text-muted)', fontSize: 14 }}>{user?.email}</span>
      </header>

      <nav style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 48 }}>
        <Link to="/clientes" style={cardStyle}>Clientes & Veículos</Link>
        <Link to="/servicos" style={cardStyle}>Catálogo de Serviços</Link>
        <Link to="/orcamentos" style={cardStyle}>Orçamentos</Link>
        <Link to="/agenda" style={cardStyle}>Agenda</Link>
        <Link to="/os" style={cardStyle}>Ordens de Serviço</Link>
        <Link to="/financeiro" style={cardStyle}>Financeiro</Link>
      </nav>

      <section>
        <h2 style={{ marginBottom: 16, fontSize: 16, color: 'var(--color-text-muted)' }}>Resumo</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
          <div style={statStyle}>
            <strong style={{ fontSize: 24 }}>0</strong>
            <span style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>Orçamentos hoje</span>
          </div>
          <div style={statStyle}>
            <strong style={{ fontSize: 24 }}>0</strong>
            <span style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>Em serviço</span>
          </div>
          <div style={statStyle}>
            <strong style={{ fontSize: 24 }}>R$ 0</strong>
            <span style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>Receita no mês</span>
          </div>
        </div>
      </section>
    </div>
  );
}

const cardStyle: React.CSSProperties = {
  padding: 24,
  background: 'var(--color-surface)',
  borderRadius: 'var(--radius)',
  border: '1px solid var(--color-border)',
  color: 'var(--color-text)',
  fontWeight: 500,
  textAlign: 'center',
};

const statStyle: React.CSSProperties = {
  padding: 20,
  background: 'var(--color-surface)',
  borderRadius: 'var(--radius)',
  border: '1px solid var(--color-border)',
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
};